import { o2oApi } from 'yxt-biz-pc/packages/api';

// 获取面授信息和场次信息
export const getFlipInfoAndScenes = (taskId) => {
  return o2oApi.get(
    `tasks/getFlipInfoAndScenes/${taskId}`
  );
};
